import { Component, input, OnInit, output } from '@angular/core';
import { Router } from '@angular/router';
import { InspectionItemDetails } from 'src/app/models/inspection.model';
import { CoreService } from 'src/app/services/core/core.service';
import { VehicleProvider } from 'src/app/services/providers/vehicle-provider/vehicle-provider';

@Component({
  selector: 'app-pre-use-inspection-list',
  templateUrl: './pre-use-inspection-list.component.html',
  styleUrls: ['./pre-use-inspection-list.component.scss'],
  standalone: false
})
export class PreUseInspectionListComponent implements OnInit {

  itemsList = input<InspectionItemDetails[]>([]);

  constructor(
    private readonly coreService: CoreService,
    private readonly router: Router,
    private readonly vehicleProvider: VehicleProvider
  ) { }

  ngOnInit() { }

  get isMobileApp() {
    return this.coreService.isMobileApp;
  }

  get isActiveVehicleSelected() {
    return this.vehicleProvider.readIsActiveVehicle();
  }

  navigatePUI(rptId: number) {
    this.router.navigateByUrl(`/add-new-pre-use-inspection/${rptId}`);
  }
}
